export default "/assets/images/mila-filter-video-2.f2ceac8d948f1c4e.mp4";